// Página pública de soporte (/soporte): canales de contacto (WhatsApp, teléfono,
// email) + cómo eliminar la cuenta. El chrome (navbar + footer) lo aporta
// PageLayout. Copy en strings.support.*, datos de contacto en data/contact.ts.

import { strings } from '@/data/strings';
import { contact } from '@/data/contact';
import styles from './SupportPage.module.css';

const s = strings.support;

interface Channel {
  label: string;
  description: string;
  action: string;
  value: string;
  href: string;
  external?: boolean;
}

const CHANNELS: Channel[] = [
  {
    label: s.channels.whatsapp.label,
    description: s.channels.whatsapp.description,
    action: s.channels.whatsapp.action,
    value: contact.whatsappDisplay,
    href: contact.whatsappHref,
    external: true,
  },
  {
    label: s.channels.phone.label,
    description: s.channels.phone.description,
    action: s.channels.phone.action,
    value: contact.phoneDisplay,
    href: contact.phoneHref,
  },
  {
    label: s.channels.email.label,
    description: s.channels.email.description,
    action: s.channels.email.action,
    value: contact.email,
    href: contact.emailHref,
  },
];

export function SupportPage() {
  return (
    <div className={styles.wrap}>
      <h1 className={styles.title}>{s.title}</h1>
      <p className={styles.subtitle}>{s.subtitle}</p>

      <h2 className={styles.sectionTitle}>{s.channelsTitle}</h2>
      <ul className={styles.channels}>
        {CHANNELS.map((c) => (
          <li key={c.label} className={styles.channel}>
            <span className={styles.channelLabel}>{c.label}</span>
            <a
              className={styles.channelValue}
              href={c.href}
              {...(c.external
                ? { target: '_blank', rel: 'noopener noreferrer' }
                : {})}
            >
              {c.value}
            </a>
            <span className={styles.channelDescription}>{c.description}</span>
            <a
              className={styles.channelAction}
              href={c.href}
              {...(c.external
                ? { target: '_blank', rel: 'noopener noreferrer' }
                : {})}
            >
              {c.action}
            </a>
          </li>
        ))}
      </ul>
      <p className={styles.responseTime}>{s.responseTime}</p>

      {/* Ancla para /soporte#eliminar-cuenta — el formulario de eliminación de
          datos de Google Play debe apuntar directo al mecanismo, no a la
          página general. */}
      <section id="eliminar-cuenta" className={styles.deletion}>
        <h2 className={styles.deletionTitle}>{s.deletion.title}</h2>
        <p className={styles.deletionText}>{s.deletion.intro}</p>

        <p className={styles.deletionSubhead}>{s.deletion.optionsTitle}</p>
        <ol className={styles.optionsList}>
          {s.deletion.options.map((opt) => (
            <li key={opt}>{opt}</li>
          ))}
        </ol>

        <p className={styles.deletionSubhead}>{s.deletion.whatTitle}</p>
        <ul className={styles.whatList}>
          {s.deletion.whatItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>

        <p className={styles.deletionSubhead}>{s.deletion.whatConservedTitle}</p>
        <p className={styles.deletionText}>{s.deletion.whatConservedIntro}</p>
        <ul className={styles.whatList}>
          {s.deletion.whatConservedItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>

        <p className={styles.deletionText}>{s.deletion.timeline}</p>
        <p className={styles.deletionText}>
          {s.deletion.privacyPrompt}{' '}
          <a className={styles.inlineLink} href={s.deletion.privacyHref}>
            {s.deletion.privacyLinkText}
          </a>
          .
        </p>
      </section>
    </div>
  );
}
